export default __webpack_public_path__ + "static/media/no-image.80679be0.png";